<template>
  <div class="card" >
    <slot name="header"/>
    <div  class="card-image"
          @click="click">
      <thumbnail
        :thumbnail-url="item.thumbnailUrl"
        :thumbnail-type="entityType"
        data-int="card-thumbnail"
        class="is-square"
      />
    </div>
    <div  class="card-content"
          @click="click">
      <div class="content">
        {{ item.uri }}
        <p data-int="card-name"
           class="has-text-centered truncate is-marginless"
           data-toggle="tooltip"
           :title="item.name">
          <template v-if="isWidget && item.uri">
            <a  class="has-text-link">
              <strong>{{ item.name }}</strong>
            </a>
          </template>
          <template v-else-if="!!item.type">
            <strong class="has-text-link">{{ item.name }}</strong>
          </template>
          <template v-else>
            <p>
              <strong class="has-text-link">{{ item.name }}</strong>
            </p>
          </template>
        </p>
        <p  v-if="!hideIdentifier" 
            :title="renderedIdentifier"
            data-int="card-identifier"
            class="subtitle is-size-6 has-text-centered truncate-subtitle"
            data-toggle="tooltip">
          {{ renderedIdentifier }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import Thumbnail from '@/components/common/Thumbnail';

export default {
  name: 'Card',
  emits: ['navToWidget', 'click'],
  components: {
    Thumbnail
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    isWidget: Boolean
  },
  computed: {
    uri() {
      if (this.entityType && (this.item.entityId || this.item.id)) {
        return `/${this.entityType}/${this.item.entityId || this.item.id}`;
      }
      return '';
    },
    entityType() {
      return (
        this.item.contentType || this.item.mediaType || this.item.entityType
      );
    },
    hideIdentifier () {
      switch (this.entityType) {
        case 'part': 
        case 'page':
          return false
        default:
          return this.$store.state.user.hideIdentifier
      }
  },
    renderedIdentifier() {
      switch (this.entityType) {
        case "productpage":
          return this.item.productId ?? ""
        default:
          return this.item.identifier
      }
    }
  },
  methods: {
    click() {
      if (this.isWidget) {
        this.$emit('navToWidget', this.item)
      } else {
        this.$emit('click', this.item)
      }
    }
  }
};
</script>

<style scoped>
.card {
  height: 100%;
  max-width: 200px;
  cursor: pointer;
}
.card-content {
  padding: 0.5rem;
  line-height: normal;
}
.card-image {
  padding: 1rem;
}
.truncate {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -moz-box-orient: block-axis;
  -webkit-box-orient: block-axis;
  min-height: 2rem;
}
.truncate-subtitle {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -moz-box-orient: block-axis;
  -webkit-box-orient: block-axis;
}
</style>
